// eslint-disable-next-line import/no-cycle
import { ssoLogin } from '@/api/sso';
import Cookies from 'js-cookie';
import { trackEvent, getUTMParams } from '@/utils/analytics';

const TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'x-refresh-token';

const isLogin = () => {
  return !!Cookies.get(TOKEN_KEY) || !!Cookies.get(REFRESH_TOKEN_KEY);
};

const getAccessToken = () => {
  return Cookies.get(TOKEN_KEY);
};

const getRefreshToken = () => {
  return Cookies.get(REFRESH_TOKEN_KEY);
};

const setAccessToken = (token: string) => {
  Cookies.set(TOKEN_KEY, token);
};

const clearPrimaryDomainToken = () => {
  Cookies.remove(TOKEN_KEY, {
    domain: '.parametrix.cn',
  });
  Cookies.remove(REFRESH_TOKEN_KEY, {
    domain: '.parametrix.cn',
  });
};

const clearToken = () => {
  Cookies.remove(TOKEN_KEY);
  Cookies.remove(REFRESH_TOKEN_KEY);
};

const toSSO = () => {
  trackEvent('sign_up_start', { method: 'sso', ...getUTMParams() });

  const url = new URL(window.location.href);
  url.searchParams.delete('sso_code');
  url.searchParams.delete('ssoRedirect');
  const currentUrl = url.toString();
  const targetUrl = `${
    import.meta.env.VITE_SSO_URL
  }/login?ssoRedirect=${encodeURIComponent(
    currentUrl
  )}&applicationType=individual&app=knit`;
  window.location.href = targetUrl;
};

const loginWithSSOCode = async (ssoCode: string) => {
  const response = await ssoLogin(ssoCode);
  if (response.code === 0 && response.data.access_token) {
    // 存储token
    setAccessToken(response.data.access_token);
  }
};

export {
  isLogin,
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  clearPrimaryDomainToken,
  clearToken,
  toSSO,
  loginWithSSOCode,
};
